import React from "react";
import "../../components/MicrochipList/MicrochipList.css";
import CheckIcon from "@mui/icons-material/Check";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SearchIcon from "@mui/icons-material/Search";

const MicrochipQuantity = ({
  userDetailResponse,
  setOpenProfile,
  openProfile,
}) => {



  const data = [
    {
      id: 1,
      productName: "Dog Microchip",
      inventoryCount: 45,
      cities: [
        { city: "Gurugram", quantity: 15, status: "Active" },
        { city: "Mumbai", quantity: 15, status: "Active" },
        { city: "Bengaluru", quantity: 15, status: "Active" },
        { city: "Delhi", quantity: 15, status: "Active" }
      ]
    },
    {
      id: 2,
      productName: "Cat Microchip",
      inventoryCount: 45,
      cities: [
        { city: "Gurugram", quantity: 15, status: "Active" },
        { city: "Mumbai", quantity: 15, status: "Active" },
        { city: "Bengaluru", quantity: 15, status: "Active" },
        { city: "Delhi", quantity: 15, status: "Active" }
      ]
    }
  ];

  
  //console.log(userDetailResponse);
  return (
   <>
   
   <div style={{ margin: '20px' }}>
      <button style={{ marginRight: '10px' }}>Add Microchip</button>
      <button>Download Excel</button>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
        <thead>
          <tr className="microchipListHeading" style={{ backgroundColor: '#6A6A6A', color: 'white' }}>
            <th style={{ padding: '10px', border: '1px solid #6A6A6A' }}>S no.</th>
            <th style={{ padding: '10px', border: '1px solid #6A6A6A' }}>Product Name</th>
            <th style={{ padding: '10px', border: '1px solid #6A6A6A' }}>Inventory Count</th>
            <th style={{ padding: '10px', border: '1px solid #6A6A6A' }}>Cities</th>
            <th style={{ padding: '10px', border: '1px solid #6A6A6A' }}>Quantity</th>
            <th style={{ padding: '10px', border: '1px solid #6A6A6A' }}>Status</th>
            <th style={{ padding: '10px', border: '1px solid #6A6A6A' }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <React.Fragment key={item.id}>
              <tr>
                <td style={{ padding: '10px', border: '1px solid #6A6A6A', textAlign: 'center' }} rowSpan={item.cities.length}>
                  {String(index + 1).padStart(2, '0')}
                </td>
                <td style={{ padding: '10px', border: '1px solid #6A6A6A', textAlign: 'center' }} rowSpan={item.cities.length}>
                  {item.productName}
                </td>
                <td style={{ padding: '10px', border: '1px solid #6A6A6A', textAlign: 'center' }} rowSpan={item.cities.length}>
                  {item.inventoryCount}
                </td>
                <td style={{ padding: '10px', border: '1px solid #6A6A6A', textAlign: 'center' }}>
                  {item.cities[0].city}
                </td>
                <td style={{ padding: '10px', border: '1px solid #6A6A6A', textAlign: 'center' }}>
                  {item.cities[0].quantity}
                </td>
                <td style={{ padding: '10px', border: '1px solid #6A6A6A', textAlign: 'center' }}>
                  <span style={{ color: 'green', fontWeight: 'bold' }}>{item.cities[0].status.toUpperCase()}</span>
                </td>
                <td style={{ padding: '10px', border: '1px solid #6A6A6A', textAlign: 'center' }} rowSpan={item.cities.length}>
                  <button
                    style={{
                      height: "35px",
                      width: "35px",
                      backgroundColor: "#F1F1F1",
                    }}
                    onClick={() => setOpenProfile(!openProfile)}
                  >
                    <EditOutlinedIcon className="icon" />
                  </button>
                  <button
                    style={{
                      height: "35px",
                      width: "35px",
                      marginLeft: "5px",
                      backgroundColor: "#F4616F",
                      borderColor: "#FF0000",
                    }}
                  >
                    <DeleteOutlinedIcon className="icon" />
                  </button>
                </td>
              </tr>
              {item.cities.slice(1).map((city, cityIndex) => (
                <tr key={cityIndex}>
                  <td style={{ padding: '10px', border: '1px solid #6A6A6A', textAlign: 'center' }}>
                    {city.city}
                  </td>
                  <td style={{ padding: '10px', border: '1px solid #6A6A6A', textAlign: 'center' }}>
                    {city.quantity}
                  </td>
                  <td style={{ padding: '10px', border: '1px solid #6A6A6A', textAlign: 'center' }}>
                    <span style={{ color: 'green', fontWeight: 'bold' }}>{city.status.toUpperCase()}</span>
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>

   </>
  );
};

export default MicrochipQuantity;
